<div class="w-full h-fit bg-[var(--p-primary-950)]">
  <div
    class="w-full max-w-[1280px] mx-auto h-fit py-[64px] md:py-[128px] flex flex-col gap-[32px] md:gap-[64px] justify-center items-center"
  >
    <div
      class="px-[20px] md:px-[40px] text-[20px] leading-7 md:text-[32px] md:leading-12 font-bold text-[var(--p-primary-400)]"
    >
      {{ 'NEWS' }}
    </div>

    <div
      class="px-[20px] md:px-[40px] text-[32px] leading-12 md:text-[48px] md:leading-16 font-bold text-[var(--p-primary-50)] text-center"
    >
      {{ 'home.news' | translate }}
    </div>

    <div class="pl-5 md:pl-10 w-full h-fit max-w-[768px]">
      <p-tabs [value]="selectedYear()" class="home-category-chip-tabs">
        <p-tablist>
          @for (news of newsList; track news.year) {
            <p-tab
              (click)="clickYear(news.year)"
              [class.selected]="news.year === selectedYear()"
              [value]="news.year"
            >
              {{ news.year }}
            </p-tab>
          }
        </p-tablist>
      </p-tabs>
    </div>

    <!-- 뉴스 그리드 데스크탑, 태블릿 -->
    <div
      class="px-[20px] md:px-[40px] flex-col gap-[64px] justify-center items-center hidden md:flex"
    >
      <div class="news-grid">
        @for (item of displayedNewsForDesktop; track item.id) {
          <div
            [style]="{
              flex: displayedNewsForDesktop.length > 3 ? '0 1 calc(25% - 18px)' : '1',
            }"
            class="news-card"
          >
            <a [href]="item.url" rel="noopener" target="_blank">
              <div class="flex flex-col gap-[24px]">
                <img
                  [alt]="item.title || 'news image'"
                  [src]="item.imgPath"
                  class="aspect-square object-cover w-full h-full"
                />
                <div class="w-full flex flex-col gap-[8px]">
                  <div
                    class="line-clamp-1 text-[var(--p-primary-200)] font-bold leading-[28px] text-[20px]"
                  >
                    {{ item.newsDescription[0].title }}
                  </div>
                  <div class="text-[var(--p-surface-600)] font-medium leading-6 text-[16px]">
                    {{ item.newsDate | newsDate: appService.usedLanguage() }}
                  </div>
                  <div
                    class="text-[var(--p-primary-200)] leading-[20px] text-[16px] line-clamp-3 break-all"
                  >
                    {{ item.newsDescription[0].content }}
                  </div>
                </div>
              </div>
            </a>
          </div>
        }
      </div>
      @if (displayedNewsForDesktop.length < displayedNews.length) {
        <p-button
          (click)="getMoreNews()"
          [styleClass]="'gray-button-border'"
          [style]="{ width: 'fit-content', height: '60px', padding: '16px 16px 16px 24px' }"
          class="hidden md:flex"
        >
          <div class="flex gap-[4px] justify-center items-center text-[20px] font-medium">
            {{ 'home.more' | translate }}
            <img alt="arrow" class="w-[28px] h-[28px]" src="/images/common/arrow-down.svg" />
          </div>
        </p-button>
      }
    </div>

    <!-- 뉴스 태블릿 -->
    <div class="w-full pl-[20px] md:hidden">
      <ngx-flicking [options]="flickingOptions" class="pr-[20px]">
        @for (item of displayedNews; track item.id) {
          <div class="w-[168px] flex flex-col mr-[24px]" flicking-panel>
            <a [href]="item.url" rel="noopener" target="_blank">
              <div class="flex flex-col gap-[24px]">
                <img
                  [alt]="item.title || 'news image'"
                  [src]="item.imgPath"
                  class="aspect-square object-cover w-full h-full"
                />
                <div class="w-full flex flex-col gap-[8px]">
                  <div
                    class="line-clamp-1 text-[var(--p-primary-200)] font-bold leading-[24px] text-[16px]"
                  >
                    {{ item.newsDescription[0].title }}
                  </div>
                  <div class="text-[var(--p-surface-600)] font-medium leading-5 text-[14px]">
                    {{
                      item.newsDate
                        | date
                          : (appService.usedLanguage() !== LanguageType.Fr
                              ? 'yyyy.MM.dd'
                              : 'dd.MM.yyyy')
                    }}
                  </div>
                  <div
                    class="text-[var(--p-primary-200)] font-medium leading-[20px] text-[14px] line-clamp-3"
                  >
                    {{ item.newsDescription[0].content }}
                  </div>
                </div>
              </div>
            </a>
          </div>
        }
      </ngx-flicking>
    </div>
  </div>
</div>
